import { EMPTY_PUBLISHER } from "../constants";
export const generateReportLatestIdKey = (key) => {
    return `latest_report_id:${key}`;
};
/** Get file sha256 hash from info metadata
 * @param info Component info metadata
 */
export function getSha256(info) {
    const hashPair = info.hashes.find((hash) => hash[0] === "sha256");
    return hashPair ? hashPair[1] : "";
}
function fileIsFileBasic(file) {
    return file.unnamed !== undefined;
}
/** Get file name from info metadata
 * @param info Component info metadata
 */
export const getFileName = (info) => {
    if (fileIsFileBasic(info) && info.unnamed) {
        return info.alias ? info.alias : info.name;
    }
    else {
        return info.name;
    }
};
/** Estimate table height based on total number of items
 * @param totalCount Total number of items
 */
export function estimateTableHeight(totalCount) {
    const pagination = 72;
    const tableHeader = 76;
    const row = 36;
    if (totalCount > 10)
        return tableHeader + row * 10 + pagination;
    else
        return tableHeader + row * totalCount;
}
export const matchesFilterOrEmptyPlaceholder = (value, filter, placeholder) => {
    if (!filter)
        return true;
    if (!value && filter === placeholder) {
        return true;
    }
    else {
        return value === filter;
    }
};
export const publisherMatchesFilter = (publisher, filter) => {
    return matchesFilterOrEmptyPlaceholder(publisher, filter, EMPTY_PUBLISHER);
};
export function isCopyleftLicense(license) {
    return license.startsWith("Copyleft");
}
//# sourceMappingURL=common.js.map